<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_301_5981)">
      <rect y="0.566406" width="24" height="24" rx="12" fill="#A9A9A9" />
      <path
        d="M14.5071 16.3277V25.6218H10.947V16.3277H7.97021V12.7056H10.947V10.0344C10.947 6.93456 12.7489 5.24658 15.3809 5.24658C16.6416 5.24658 17.7253 5.3452 18.041 5.38934V8.62896L16.2155 8.6298C14.7842 8.6298 14.5071 9.34444 14.5071 10.3931V12.7056H17.9208L17.4762 16.3277H14.5071Z"
        fill="#1F1F1F"
      />
    </g>
    <defs>
      <clipPath id="clip0_301_5981">
        <rect y="0.566406" width="24" height="24" rx="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "AppFacebookIcon",
};
</script>
